import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { colors, surfaces, buttons, header } from "../styles/index";
import { useProfile, isOwner } from "../context/ProfileContext";
import { useStudioTours } from "../reacttour/StudioTourContext";
import { listPlans } from "../game-builder/api/gameBuilderAPI";

// The workspace header (from logistics-workflow): the brand, the org, and the avatar menu - walkthrough, settings, sign out.
const Header = ({ logout }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef(null);
  const avatar = localStorage.getItem("avatarEmoji") || "👤";
  const { profile } = useProfile();
  const { startTour } = useStudioTours();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const go = (fn) => () => { setMenuOpen(false); fn(); };

  return (
    <header style={header.container}>
      <div style={header.brandContainer} onClick={() => navigate("/app")}>
        <img src="/logo.svg" alt="" style={header.logo} />
        <span style={header.brandText}>SimulateJob</span>
      </div>

      <div ref={menuRef} style={{ position: "relative", display: "flex", alignItems: "center", gap: 12 }}>
        {profile?.org?.org_name && (
          <span style={{ color: colors.textMuted, fontSize: "0.9rem" }} className="hide-mobile">{profile.org.org_name}</span>
        )}
        <button
          type="button"
          id="avatar-menu"
          onClick={() => setMenuOpen((prev) => !prev)}
          style={{ ...buttons.secondary, padding: "8px 12px", borderRadius: 999, minWidth: 40 }}
          title={profile?.email || "Your account"}
          aria-haspopup="menu"
          aria-expanded={menuOpen}
        >
          {avatar}
        </button>

        {menuOpen && (
          <div style={{ ...surfaces.card, ...header.menu }} role="menu">
            {profile && (
              <div style={{ padding: "6px 12px 10px", fontSize: "0.85rem", color: colors.textMuted }}>
                {profile.email}<br />{isOwner(profile) ? "Owner" : "Creator"}
              </div>
            )}
            <MenuItem onClick={go(async () => {
              navigate("/app/dashboard");
              const hasPlans = await listPlans().then((d) => d.plans.length > 0).catch(() => false);
              startTour("welcome", { hasPlans, isDemo: !!profile?.org?.is_demo, isOwner: isOwner(profile) });
            })}>
              Start the walkthrough
            </MenuItem>
            <MenuItem onClick={go(() => navigate("/app/settings?section=walkthroughs"))}>All walkthroughs</MenuItem>
            <MenuItem onClick={go(() => navigate("/app/settings"))}>Settings</MenuItem>
            <div style={{ height: 1, background: colors.border, margin: "8px 0" }} />
            <MenuItem danger onClick={go(() => logout())}>Sign out</MenuItem>
          </div>
        )}
      </div>
    </header>
  );
};

const MenuItem = ({ children, onClick, danger }) => (
  <div
    role="menuitem"
    tabIndex={0}
    onClick={onClick}
    onKeyDown={(e) => { if (e.key === "Enter") onClick(); }}
    style={{ ...header.menuItem, ...(danger ? header.menuItemDanger : {}) }}
    onMouseEnter={(e) => { e.currentTarget.style.background = colors.bgSoft; }}
    onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
  >
    {children}
  </div>
);

export default Header;
